import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Renders contributor line for a published expert note; links to Find designer when designer_id is present.
 */
export default function ExpertNoteByline({
  note,
  className = 'text-xs font-medium mt-2',
  inline = false,
  linkClassName = 'text-blue-900 hover:underline font-medium',
}) {
  const label = note?.contributor_label;
  if (!label) return null;
  const designerId = note?.designer_id;
  const linkClass = linkClassName;
  const inner =
    designerId ? (
      <Link to={`/find-designer?designer=${encodeURIComponent(designerId)}`} className={linkClass}>
        {label}
      </Link>
    ) : (
      label
    );
  if (inline) {
    return <span className={className}>{inner}</span>;
  }
  return <p className={className}>{inner}</p>;
}
